import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Step, Workflow } from './Workflow';
import useFeature from 'hooks/useFeature';
import { selectPrequalOffer } from 'state/prequalOffer';
import { FeatureGroups } from 'state/tenant';
import useResponsiveQuery from 'hooks/useResponsiveQuery';

const usePrequalPhoneLookupWorkflow = () => {
  const { isGroupEnabled } = useFeature();
  const { prequalificationId } = useSelector(selectPrequalOffer);
  const { isMobile } = useResponsiveQuery();

  const getWorkflow = useCallback((): Workflow => {
    return {
      stepsEnabled: {
        [Step.CONSUMER_SEARCH]: true,
        [Step.PREQUAL_OFFER_APPLICATION]: true,
        [Step.APPLICATION]: true,
        // Credit application has a second step, whereas prequalification
        // does not.
        [Step.APPLICATION_2]: !prequalificationId && isMobile,
        [Step.ADD_ONS]: isGroupEnabled(FeatureGroups['add-ons']),
        [Step.REVIEW_TERMS]: true,
      },
      paths: {
        [Step.CONSUMER_SEARCH]: '/prequal/phone-lookup',
        [Step.PREQUAL_OFFER_APPLICATION]: '/prequal/offer-application',
        [Step.APPLICATION]: '/prequal/application',
        [Step.ADD_ONS]: '/add-ons',
        [Step.REVIEW_TERMS]: '/prequal/review-terms',
      },
      progressStartStep: Step.PREQUAL_OFFER_APPLICATION,
      restartStep: Step.CONSUMER_SEARCH,
      timeoutRestartPath: '/prequal/phone-lookup',
    };
  }, [isGroupEnabled, isMobile, prequalificationId]);

  return getWorkflow;
};

export default usePrequalPhoneLookupWorkflow;
